import {FlowLayout} from "../../layouts/flow-layout/FlowLayout";
import {useParams, Routes, Route, useNavigate} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import {doc, onSnapshot} from "firebase/firestore";
import {db} from "../../config/firebase";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";
import {useAtom} from "jotai";
import {ChatDrawerAtom} from "./atoms";
import {setBaseURL} from "../../config/axios-chatbot";
import {ProtectedRoute} from "../protected-route";
import {projectRoutes} from "./project-routes";
import {setBaseURLNeo4j} from "../../config/axios-neo4j";
import {setBaseMCPUrl} from "../../config/axios-mcp";
import {Context, buildFlowVariables} from "../../context/AppContext";
import {useMediaQuery, useTheme} from "@mui/material";
import {MobileUnavailable} from "../../components/MobileUnavailable";

export const ProjectHomePage = () => {
  const {projectId} = useParams();
  const {getAllServersWithDetails, getAllKbTopics} = useContext(Context);

  const [project, setProject] = useState(null);
  const [chatDrawer, setChatDrawer] = useAtom(ChatDrawerAtom)
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (projectId) {
      const unsubscribe = onSnapshot(doc(db, "projects", projectId), (doc) => {
        const newProject = doc.data() || {};
        if (newProject === undefined || newProject?.id === undefined || !newProject || !newProject?.id) {
          navigate("/projects")
        }
        newProject.id = projectId;
        newProject.flow_variables = buildFlowVariables(newProject);
        console.log("Flow variables", newProject?.flow_variables)
        setBaseURL(newProject?.configuration?.conversation_logger_api || process.env.REACT_APP_CHATBOT_BACKEND);
        setBaseURLNeo4j(newProject?.configuration?.neo4j_api || process.env.REACT_APP_CHATBOT_BACKEND);
        setBaseMCPUrl(newProject?.configuration?.mcp_registry || "");
        setProject(newProject);
        if (newProject?.configuration?.mcp_registry) {
          getAllServersWithDetails(projectId)
        }
        if (newProject?.settings?.organization) {
          getAllKbTopics(newProject.settings.organization)
        }
      });

      return () => unsubscribe();
    }
  }, [projectId])

  return (
    <FlowLayout
      project={project}
      toggleChat={() => {
        setChatDrawer(prev => ({open: !prev.open, startNode: project?.entryNode || null}))
      }}
      openChat={chatDrawer?.open}
    >
      {
        project === null ? <LoadingScreen/> :
          <Routes>
            {projectRoutes.map(({path, element: Component, roles, desktopOnly}) => (
              <Route
                key={path}
                path={path}
                element={
                  <ProtectedRoute
                    element={desktopOnly && isMobile
                      ? <MobileUnavailable/>
                      : <Component project={project} setProject={setProject} openChat={chatDrawer?.open}/>
                    }
                    allowedRoles={roles}
                    project={project}
                  />
                }
              />
            ))}
          </Routes>
      }
    </FlowLayout>
  )
}
